module.exports = __webpack_public_path__ + "img/jgh1.78cea286.jpg";